import { render, staticRenderFns } from "./tinkUser.vue?vue&type=template&id=e02ab370"
import script from "./tinkUser.vue?vue&type=script&lang=js"
export * from "./tinkUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports